import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface ProductEditorViewProps {
	productRequest: DropdownRequest<ProductSummary>;
	value: number | number[] | null;
	multi?: boolean;
	mode: ControlMode;
	onChanged: (number: ProductSummary | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	productType?: number;
	categoryId?: number;
	regionId?: number;
	fromPlaceId?: number;
	toPlaceId?: number;
	placeId?: number;
	serviceId?: number;
	baseProductDisable?: boolean;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
}

@observer
export class ProductEditorView extends React.Component<ProductEditorViewProps, any> {
	public constructor(props) {
		super(props);
	}
	private disableOption = (item: ProductSummary): boolean => !item.isLeaf;

	public render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Product';
		}
		let filters = [{ 'categoryId': this.props.categoryId },
		{ 'toPlaceId': this.props.toPlaceId },
		{ 'regionId': this.props.regionId },
		{ 'fromPlaceId': this.props.fromPlaceId },
		{ 'placeId': this.props.placeId },
		{ 'serviceId': this.props.serviceId }
		]
		return (
			<div className='filter-panel'>
				<DropdownView
					required={this.props.required}
					onGetErrorMessage={this.props.onGetErrorMessage}
					label={label}
					multi={this.props.multi}
					disabled={this.props.mode == 'display'}
					model={this.props.value}
					onChanged={this.props.onChanged}
					request={this.props.productRequest}
					keyField='id'
					textField='displayName'
					disableOption={this.props.baseProductDisable && this.props.baseProductDisable == true ? this.disableOption : undefined}
					optionRenderer={(item: ProductSummary) => (
						item.parentProductId !== null
							? (
								<React.Fragment>
									{`${item.parentDisplayName}-${item.displayName}`}
								</React.Fragment>
							)
							: (
								<React.Fragment>
									{`${item.displayName}`}
								</React.Fragment>
							)
					)
					}
					cascadeField={"productType"}
					cascadeValue={this.props.productType}
					filters={filters}
					afterLoad={this.props.afterLoad}
				/>
				<div style={{ display: 'inline-flex', alignItems: 'flex-end', marginBottom: '6px' }}>
					{this.props.children}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/products/parts/product-editor.view.tsx